import React, { MouseEventHandler } from 'react';
import { toast } from 'react-toastify';

import { CalciteAction } from '@esri/calcite-components-react';

const closeButton = ({
  closeToast,
}: {
  closeToast?: MouseEventHandler<HTMLCalciteActionElement>;
}) => <CalciteAction icon="x" text="Close" onClick={closeToast} />;

export const makeToastError = (title: string, message: string): void => {
  toast.error(
    <>
      <strong>{title}</strong>
      <div>{message}</div>
    </>,
    {
      closeButton,
    }
  );
};

export const makeToastInfo = (infoMsg: string): void => {
  toast.info(<div>{infoMsg}</div>, {
    closeButton,
  });
};
